/**
  table内部cell中的动态输入组件

*/

// import {
//   nodes
// }
// from "../../form-create/core/cvm"
//

import objectUtil from '../../../static/js/objectUtil'
import template from '../../../static/js/template'
import compileVariableUtil from '../../../static/js/compileVariableUtil'
import validateConverterUtil from '../../dynamicFrom/libs/validateConverterUtil'
import doubleRowSurface from './doubleRowSurface.vue'
import dynamicItemUtil from '../../dynamicFrom/libs/dynamicItemUtil'
import FormItem from '../../dynamicFrom/FormItem.vue'
const getValue = objectUtil.getValueByPath
// import vueUtils from "../../../static/js/vueUtils"

export default {
  name: 'editCellDynamic',
  components: {
    doubleRowSurface,
    FormItem,
  },
  props: {
    store: {
      type: Object,
      default: null,
    },
    // 扩展对象属性会出现在，绑定模板变量的 extend 中
    extendData: {
      type: Object,
      default: null,
    },
    //cell 定义，重点判断是否有输入值组件定义
    editformItem: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Array, Object],
      default: null,
    },
    dataIndex: null,
    openValidation: {
      type: Boolean,
    },
    doubleRow: {
      type: String,
      default: '',
    },
    isDraggableContainer: {
      type: Boolean,
      default: false,
    },
    //启用校验时候，指定校验的key
    rowDataKey: {
      type: String,
      default: 'items',
    },
    useMaster: {
      type: Boolean,
      default: false,
    },
    doubleRowDataKey: {
      type: String,
      default: 'item_',
    },
    validateTable: {
      type: Boolean,
      default: true,
    },
    enableCellEdit: Boolean, // 是否启用单元格编辑
    sourceData: Array, // 用于 crudArrayOrder 组件，修改其未被监听的源数据..
  },
  data() {
    this.parentDataKey = getValue(this.store, 'states.parentDataKey', 'parentFormData')
    return {
      data: this.value || {},
      changeValue: '',
    }
  },
  watch: {
    value(val) {
      this.data = val || {}
    },
  },
  beforeDestroy() {
    //vueUtils.removeAtt(this.data);
    // console.log('editCellDynamic:beforeDestroy');
    this.data = null
  },
  methods: {
    //处理验证
    validateConverterhandle(item, rowData) {
      var fCreateApi = {}
      fCreateApi.getFormData = function () {
        return rowData
      }

      let validators
      if (item.validators) {
        validators = JSON.parse(JSON.stringify(item.validators))
      } else {
        validators = item.validators
      }
      var validates = validateConverterUtil.converterValidates(validators, item, fCreateApi)
      //  console.log("validateConverterhandle",validates);
      return validates
    },

    /**
                  包装到验证框架itemform中。
                  @param {function} render 渲染方法
                  @param {object} editformItem 元素定义
                  @param {array} children 子元素列表
                */
    createItemForm(h, editformItem, children, rowData) {
      let propStr = ''
      if (this.rowDataKey) {
        propStr = this.rowDataKey + '[' + this.dataIndex + '].' + editformItem.property
      } else {
        propStr = 'items[' + this.dataIndex + '].' + editformItem.property
      }
      if (this.store && this.validateTable) {
        this.store.commit('setTableValidate', editformItem)
      }
      var propsData = {
        key: editformItem.property + this.dataIndex,
        prop: propStr,
        labelWidth: 0.1,
        rules: this.validateConverterhandle(editformItem, rowData),
        changeValue: this.changeValue,
      }
      //  console.log("createItemForm", propsData);
      var vNodeFn = h(
        'form-item',
        {
          props: propsData,
          class: {
            'pg-form-item-minWidth':
              editformItem.required ||
              (editformItem.validators && editformItem.validators.length > 0),
          },
          style: {
            marginBottom: '0px',
            padding: '0',
          },
        },
        children
      )

      return vNodeFn
    },
    /**
                  包装到布局组件中
                  @param {function} render 渲染方法
                  @param {object} editformItem 元素定义
                  @param {array} children 子元素列表
                */
    createLayout(h, layout, children) {
      // var _props = layout.props

      var layoutProps = null
      if (layout.props) layoutProps = Object.assign({}, layout.props) //避免使用观察数据对象作为VNoad数据

      var vNodeFn = h(
        layout.type,
        {
          props: layoutProps,
        },
        children
      )
      return vNodeFn
    },
    /**
     * [createDoubleRowSurface  创建双行显示的包装]
     * @param  {[type]} h         [description]
     * @param  {[type]} doubleRow [description]
     * @param  {[type]} children  [description]
     * @return {[type]}           [description]
     */
    createDoubleRowSurface(h, item, children, componentClassName, propsCompile) {
      let propsData = {
        doubleRow: this.doubleRow,
        item: item,
        rowData: this.data,
        componentClassName: componentClassName,
        propsCompile: propsCompile,
        doubleRowDataKey: this.doubleRowDataKey,
        renderComponent: item.parameter?.renderComponent ?? false,
      }
      var vNodeFn = h(
        'doubleRowSurface',
        {
          props: propsData,
        },
        children
      )

      return vNodeFn
    },

    /**
                  包装到拖拽组件中
                  @param {function} render 渲染方法
                  @param {object} editformItem 元素定义
                  @param {array} children 子元素列表
                */
    // createDraggableContainer(h, editformItem, children) {
    //   var options = this.dynamicFromProvide.options

    //   var propsData = {
    //     visible: editformItem.visible,
    //     inline: isInline,
    //     data: editformItem.field,
    //   }

    //   var optionOn = {
    //     drop: (value) => {
    //       //  alert("drop,value");
    //       options.designOptions.handlerDrop(value)
    //     },
    //     click: (value) => {
    //       //  alert("drop,value");
    //       options.designOptions.handlerClick(value)
    //     },
    //     dblclick: (value) => {
    //       //  alert("drop,value");
    //       options.designOptions.handlerDbclick(value)
    //     },
    //   }

    //   var vNodeFn = h(
    //     'draggable-container',
    //     {
    //       props: propsData,
    //       on: optionOn,
    //     },
    //     children
    //   )
    //   return vNodeFn
    // },
    // 判断oldValue newValue是否相同
    isEqual(oldValue, newValue) {
      const isLike =
        typeof oldValue === 'object' && typeof newValue === 'object'
          ? JSON.stringify(oldValue) === JSON.stringify(newValue)
          : oldValue === newValue
      return isLike
    },
  },

  render(h) {
    //  console.log("watch.render,this.data,this.dataIndex",this.data,this.dataIndex);
    var _vm = this
    var item = this.editformItem
    var componentClassName = 'readText'
    if (item.component && item.component.code) componentClassName = item.component.code
    componentClassName = dynamicItemUtil.convertComponentName(componentClassName)
    var _props = item.parameter || {}
    var field = item.property
    var isReadText = componentClassName === 'readText' || componentClassName === 'read-text'
    let vNodeFn,
      initValue = null,
      propsCompile = null
    let vNodeFnBrother = [] //用于有特殊处理需要放在配置组件平级的情况
    if (field) {
      initValue = getValue(this.data, field, 'hasOwnProperty')
      if (initValue === 'hasOwnProperty') {
        initValue = null
        //私有的属性不参与渲染，不用设置默认值
        const privateField = field.charAt(0) === '_'
        if (!privateField && (!isReadText || (isReadText && _props.setVueValue))) {
          if (this.sourceData)
            objectUtil.setValueByPath(this.sourceData, `${this.dataIndex}.${field}`, initValue)
          objectUtil.setValueByPathForVue(this.data, field, initValue, _vm)
        }
      }
      // 暂时处理发货单拆分问题（拆行临时方案）
      if (
        !this.disabled &&
        this.useMaster &&
        this.data &&
        this.data.hasOwnProperty('master') &&
        !this.data.master
      ) {
        if (
          item.code === 'goodsDetail.name' ||
          item.code === 'waresDetail.name' ||
          item.code === 'goodsInfo.name'
        ) {
          initValue = null
          componentClassName = 'readText'
        }
      }
    }
    this.changeValue = initValue // value变化之后通知 FromItem组件数据变化了很重要哦
    var propsCompileData = compileVariableUtil.getCompileVariable(this.data, this, this.extendData)
    //特殊处理传递
    propsCompileData.dataIndex = this.dataIndex
    propsCompileData.parentData =
      getValue(this.extendData, 'formData') || window[this.parentDataKey] // 兼容下formData
    propsCompileData.extendData = this.extendData // 此处 用于扩展参数，购物车模型会传入一个 extendData，以访问整个购物车数据
    propsCompileData.otherRow = false // otherRow 表示是否是从行
    propsCompileData.row = this.data // row 行数据
    try {
      propsCompile = template.render(_props, propsCompileData)
    } catch (e) {
      propsCompile = _props
    }
    // 给每个子组件传一个 唯一标识进组件，方便子组件区分
    propsCompile.conCode = field

    //当为input组件时支持设置maxlength
    if (item.length > 0 && ~['input', 'i-input', 'Input'].indexOf(componentClassName)) {
      propsCompile.maxlength = propsCompile.maxlength ?? item.length
    }
    if (item.disabled) {
      propsCompile.disabled = item.disabled
    }

    if (
      !propsCompile.noEnableCellEdit &&
      this.enableCellEdit &&
      dynamicItemUtil.isCellRender(componentClassName) &&
      !item.template
    ) {
      if (item.parameter) {
        initValue = this.$options.filters.formatFilter(
          initValue,
          item.parameter.type,
          item.parameter.format
        )
      }
      //这里为了让下拉能够正常的返回数据 增加了 resultValue 这个配置  "resultValue": {“0": "0","true": "上架","false": "下架"	}
      initValue = dynamicItemUtil.initValueTrans(initValue, propsCompile.resultValue)
      const isDisabled = propsCompile.disabled
      // console.info('isDisabled:',isDisabled,'>>>>>>>>>>>>>>>>>>>>>>>')
      let nodeChildren = [initValue]
      if (componentClassName === 'readText' && item.parameter?.otherStyle) {
        nodeChildren = h('readText', {
          props: propsCompile,
        })
      }
      if (componentClassName == 'referencePrice' && !propsCompile.disabled) {
        vNodeFnBrother.push(
          h(
            'span',
            {
              class: { 'cell-reference-price': true },
              on: {
                click: () => {
                  item._buttonClick = true
                },
              },
            },
            [propsCompile.showText ? propsCompile.showText : '参考价格']
          )
        )
      }
      //处理展示两个字段的情况
      let isSubValue = 'subValue' in propsCompile
      if (isSubValue) {
        const subValue = this.$options.filters.formatFilter(
          propsCompile.subValue,
          item.parameter.type,
          item.parameter.format
        )
        nodeChildren = [
          h(
            'div',
            { class: { 'edit-two-first': true, 'edit-two-first-disabled': isDisabled } },
            nodeChildren
          ),
          '/',
          subValue,
        ]
        nodeChildren = [h('div', { class: 'edit-two' }, nodeChildren)]
      }
      vNodeFn = h(
        'div',
        {
          class: {
            'cell-span-edit': true,
            'cell-span-disabled': isDisabled,
            'clear-style': isSubValue,
          },
        },
        nodeChildren
      )
    } else {
      // 如果设置只读模式，则优先级最高。
      if (this.disabled) {
        propsCompile.disabled = this.disabled
      }
      // 如果是 goodsItemClick 组件，把整行数据传入 props 需要在内部判断是否，可以查看商品工具包与库存信息
      if (
        componentClassName === 'goodsItemClick' ||
        componentClassName === 'fMSuperSearchModal' ||
        componentClassName === 'fMSuperForProductSearchModal'
      ) {
        propsCompile.rowData = this.data
      }

      if (propsCompile && propsCompile.dataIndex) {
        propsCompile.dataIndex = +propsCompile.dataIndex
      }
      if (componentClassName == 'setDefaultRadio') {
        propsCompile.dataIndex = this.dataIndex
        propsCompile.feild = field
      }
      // 行内点击弹出框时要将dataIndex传进去
      if (
        componentClassName == 'fMSuperSearchModal' ||
        componentClassName == 'fMSuperForProductSearchModal'
      ) {
        propsCompile.dataIndex = this.dataIndex
      }
      let optionModel = null
      initValue = item.template ? template.render(item.template, propsCompileData) : initValue
      var data = this.data
      //100 条数据。283M比202M.http://preview.cd.pangu16.com/#/panguPerformance/panguPerformance1
      // console.log("freezeData", field, propsCompile.disabled, this.disabled,
      //   componentClassName);
      // if (propsCompile.disabled) {
      //   initValue = Object.freeze(initValue);
      //   //console.log("freezeData", field);
      // }
      optionModel = {
        value: initValue,
        callback: ($$v) => {
          if (propsCompile.disabled) return
          var oldValue = getValue(this.data, field)
          // objectUtil.setValueByPathForVue(data, field, $$v, _vm);
          objectUtil.setValueByPathForVue(data, field, $$v, _vm)
          const cBorthers = _props.changeBorthers
          if (cBorthers) {
            let temp = {}
            Object.keys(cBorthers).forEach((im) => {
              let otherFields = cBorthers[im]
              if (!otherFields) {
                temp[im] = otherFields
              } else if (otherFields.startsWith('{{') && otherFields.endsWith('}}')) {
                temp[im] = template.render(otherFields, propsCompileData)
              } else {
                temp[im] = getValue($$v, otherFields)
              }
            })
            console.log('******sideSelect***this.changeBorthersObj***********', this.temp)
            Object.keys(temp).forEach((im) => {
              objectUtil.setValueByPathForVue(data, im, temp[im], _vm)
            })
          }
          this.$emit('input', data)
          this.$emit('on-change', data, field, $$v, this.dataIndex, !!cBorthers)
          //当新旧值一样的时候，不去抛出事件，防止死循环 fpr
          if (!this.isEqual(oldValue, $$v) && propsCompile.rowDataReplaceInfo) {
            this.$emit('row-data-replace', data, propsCompile.rowDataReplaceInfo, this.dataIndex)
          }
        },
      }

      //监听discountEdit组件变化抛出事件调用计算折扣
      let eventOn = {}
      if (componentClassName == 'discountEdit') {
        eventOn = {
          'on-change': (fildKey, fild) => {
            //
            this.$emit('on-change-discountEdit', data, fildKey, fild, this.dataIndex)
          },
        }
      }

      //将store向下传递
      propsCompile.store = this.store
      const vNodeParam = {
        on: eventOn,
        style: template.render(item.style, propsCompileData), // 让表格单元格组件支持样式表达式配置
      }
      //如果是component-plus库中的组件，将属性都渲染在attrs中
      if (componentClassName.indexOf('Pg') > -1) {
        vNodeParam.attrs = { value: optionModel.value, ...vNodeParam.attrs, ...propsCompile }
        vNodeParam.on = { ...vNodeParam.on, input: optionModel.callback }
      } else {
        vNodeParam.props = propsCompile
        vNodeParam.model = optionModel
      }
      vNodeFn = h(componentClassName, vNodeParam)
    }

    // 第一层包装 包装IconDiv
    /* if (propsCompile && propsCompile.layout && propsCompile.layout.type) {
                    vNodeFn = this.createLayout(h, propsCompile.layout, [vNodeFn]);
                } */

    // 只在开启校验并且可编辑才包装formitem
    if (
      this.openValidation &&
      (item.required || item.validators?.length > 0) &&
      !this.disabled &&
      !isReadText
    ) {
      vNodeFn = this.createItemForm(
        h,
        item,
        [vNodeFn, ...vNodeFnBrother],
        this.data,
        this.doubleRow
      )
    } else if (vNodeFnBrother && vNodeFnBrother.length > 0) {
      vNodeFn = h(
        'div',
        {
          class: 'pg-form-item-minWidth',
        },
        [
          h(
            'div',
            {
              style: { position: 'relative' },
            },
            [vNodeFn, ...vNodeFnBrother]
          ),
        ]
      )
    }

    // 第三层包装 包装双行显示
    if (this.doubleRow) {
      vNodeFn = this.createDoubleRowSurface(h, item, [vNodeFn], componentClassName, propsCompile)
    }

    // if(this.isDraggableContainer){
    //   vNodeFn = this.createDraggableContainer(h,this.doubleRow,[vNodeFn]);
    // }
    return vNodeFn
  },
}
